import type { Mouvement } from '@mairistem/comptabilite';
import type { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauPrepareTdtState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.PREPARE_TDT;
		this.state = BordereauStateType.PREPARE_TDT;
		this.color = '#6a0067ff';
		this.libelle = 'Préparation TDT';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		_userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [new BordereauActualiseEtatAction({ isActionPrincipale: true })];
	}

	getMouvementActions(): BaseLiquidationAction<
		Mouvement,
		MouvementActionType
	>[] {
		return [];
	}
}

export default BordereauPrepareTdtState;
